import styled from '@emotion/styled/macro';

import { FormFieldWrapper } from '../../../Form/Form';

export const StyledFormFieldWrapper = styled(FormFieldWrapper)`
  height: 3rem;
`;
